
import { Component, Vue } from 'vue-property-decorator';

@Component<FlightChiefPage>({})
export default class FlightChiefPage extends Vue {}
